import {WINNER_STATUSES} from "../../core/consts";

export const PROPOSITION_BETS = {
   firstDisplayRows: 2,
   previewRows: 1,
   previewBets: 1,

   PROGRESS_BAR: {
      strokeColor: "#304b50",

      SIZES: {
         RADIUS: {
            desktop: 22,
            mobile: 18
         },
         stroke: 4
      },

      ANIMATION: {
         duration: 1000,
         delay: 0
      }
   },

   ACTION_TYPES: {
      onPopupClick: 'onPopupClick'
   },

   ANALYTICS: {
      ACTION_TYPES: {
         onMarketClick: 'onMarketClick',
         onShowMoreClick: 'onShowMoreClick'
      },

      CLICK_TYPE: {
         open: 'open',
         close: 'close'
      },

      BOOKIE_BUTTON_TYPE: {
         odds: 1,
         betNow: 1,
      }
   },

   DETAILS: {
      ACTION_TYPES: {
         onDisplayEvent: 'onDisplayEvent'
      },

      VALUES_TYPES: {
         scores: 'Scores',
         text: 'Text'
      },

      WINNER_STATUS:{
         [WINNER_STATUSES.win]: 'GAME_CENTER_H2H_WIN',
         [WINNER_STATUSES.draw]: 'GAME_CENTER_H2H_DRAW',
         [WINNER_STATUSES.lose]: 'GAME_CENTER_H2H_LOSE'
      }
   }
}
